import { Link } from "@tanstack/react-router";

const footerNavItems = {
  main: [
    { name: "Home", href: "/" },
    { name: "Privacy", href: "/privacy" },
    { name: "Biometrics", href: "/biometric-policy" },
  ],
} as const;

export const Footer = () => (
  <footer className="pb-32 md:pb-0">
    <div className="mx-auto max-w-7xl overflow-hidden px-6 sm:py-24 lg:px-8">
      <nav className="-mb-6 flex justify-center space-x-12" aria-label="Footer">
        {footerNavItems.main.map((item) => (
          <div key={item.name} className="pb-6">
            <Link
              to={item.href}
              className="text-sm leading-6 text-foreground hover:text-muted-foreground"
            >
              {item.name}
            </Link>
          </div>
        ))}
      </nav>
      <p className="mt-10 text-center text-xs leading-5">
        &copy; {new Date().getFullYear()}, App-Order, LLC. All rights reserved.
      </p>
    </div>
  </footer>
);
